import { ReadOutlined, WechatWorkOutlined } from "@ant-design/icons";

import { getSpotlight } from "Services/ProfileFeedsApiService";

import { SpotlightRoutingItem } from "./Components/Routing/SpotlightRoutingItem";
import { DocsPreviewProps } from "./types";

export async function getDocsPreview({ query, setIsLoading }: DocsPreviewProps) {
    if (!query) {
        return [];
    }
    try {
        const result1 = await getSpotlight({ query });

        setIsLoading(true);

        const options = result1.items.map(
            (item: {
                source: {
                    category: string;
                    description: string;
                    title: string;
                    url: string;
                };
                highlight: {
                    description: string[] | undefined;
                    title: string[] | undefined;
                };
            }) => {
                const title = (item.highlight?.title?.join(" ") ?? item.source.title)
                    .replaceAll("<em>", "<span class='highlight'>")
                    .replaceAll("</em>", "</span>");
                const description = (item.highlight?.description?.join(" ") ?? item.source.description)
                    .replaceAll("<em>", "<span class='highlight'>")
                    .replaceAll("</em>", "</span>");
                return {
                    label: (
                        <SpotlightRoutingItem
                            icon={item.source.category == "user-docs" ? <ReadOutlined /> : <WechatWorkOutlined />}
                            name={title}
                            description={description}
                            searchValue={""}
                            route=""
                            onCallback={() => {
                                window.open(item.source.url, "_blank");
                            }}
                        />
                    ),
                    value: item.source.url,
                };
            }
        );
        setIsLoading(false);
        return [
            {
                label: "Regal Docs",
                options,
            },
        ];
    } catch {
        return [];
    } finally {
        setIsLoading(false);
    }
}

export const getRelevanceScore = (item: any, searchTerm: string) => {
    const searchLower = searchTerm.toLowerCase();
    const label = typeof item.label === "string" ? item.label : "";
    const description = typeof item.description === "string" ? item.description : "";

    // Exact match at start of label
    if (label.toLowerCase().startsWith(searchLower)) {
        return 100;
    }

    // Exact match anywhere in label
    if (label.toLowerCase().includes(searchLower)) {
        return 80;
    }

    // Match in description
    if (description.toLowerCase().includes(searchLower)) {
        return 60;
    }

    // Partial match in label
    const words = searchLower.split(" ");
    const labelWords = label.toLowerCase().split(" ");
    if (words.some((word) => labelWords.some((lw: string) => lw.startsWith(word)))) {
        return 40;
    }

    return 0;
};
